import React, { FC, ReactNode, useMemo } from "react";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import { useTheme } from "../../common/contexts/ThemeContext";
import { createHubSpotMuiTheme } from "../HubSpotUi/theme";
import { useCrm } from "./useCrm";

/**
 * HubSpot's MUI theme for HubSpot orgs. Outreach orgs get no provider at all,
 * so every MUI component renders with the defaults it always had.
 */
const CrmMuiThemeProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const crm = useCrm();
  const { mode } = useTheme();
  const theme = useMemo(() => (crm === "hubspot" ? createHubSpotMuiTheme(mode) : null), [crm, mode]);

  if (!theme) return <>{children}</>;
  return <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>;
};

export default CrmMuiThemeProvider;
